export default __webpack_public_path__ + "static/media/0177.38c10cfb.png";